import React from 'react';
import type { EdgeDataT } from '../../types/relationship-renderer.type';
import RelationshipEdge from './relationship-edge';
type PropsT = {
  edges: EdgeDataT[];
};
const RelationshipRenderer = ({
  edges
}: PropsT) => {
  if (!edges || edges.length === 0) return null;
  return <g data-testid="relationship-renderer">
      {edges.map(edge => <RelationshipEdge key={edge.id} sourceCenter={edge.sourceCenter} targetCenter={edge.targetCenter} names={edge.names} color={edge.color} textColor={edge.textColor} directed={edge.directed} lineStyle={edge.lineStyle} />)}
    </g>;
};
export default RelationshipRenderer;